module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"articles":{"action":"Beitrag anfragen","empty_state":"Sie möchten auch einen Beitrag auf CAPinside veröffentlichen? Dann schreiben Sie uns eine Nachricht mit Ihren Themenvorschlägen.","title":"Artikel"}}}}}}}')
  delete Component.options._Ctor
}
